import PublicTerritoryDTO from "../../models/territory/PublicTerritoryDTO";
import axios from "axios";
import BackendClient from "../../BackendClient";

export function listTerritories(client: BackendClient, includeDeleted: boolean): Promise<Array<PublicTerritoryDTO>> {
    const headers = {
      'Authorization': `${client.getAuthEntity()} ${client.getAuthToken()}`,
    };

    return new Promise<Array<PublicTerritoryDTO>>((resolve, reject) => {
      axios.get(`${client.getBackendUrl()}${BackendClient.ListTerritories}`, {headers: headers, params: {includeDeleted: includeDeleted}})
        .then((response) => resolve(response.data))
        .catch((reason) => {
          console.log(`Exception when trying to listTerritories: ${JSON.stringify(reason)}`)
          reject(reason);
        });
    });
  }